module.exports = __webpack_public_path__ + "assets/loops-tree.737ee945.svg";